var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "formAddPerformance",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          return [
            _c(
              "b-form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.formSubmitted($event)
                  },
                },
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Reward Title",
                              "label-for": "awardTitle",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                rules: "required",
                                name: "Reward Title",
                                vid: "awardTitle",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            name: "awardTitle",
                                            placeholder: "Reward Title",
                                          },
                                          model: {
                                            value:
                                              _vm.performanceRecord.awardTitle,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.performanceRecord,
                                                "awardTitle",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "performanceRecord.awardTitle",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { sm: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Employee",
                              "label-for": "employeeId",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                rules: "required",
                                name: "Employee",
                                vid: "employee",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-select", {
                                          attrs: {
                                            id: "employeeId",
                                            options: _vm.employeeOptions,
                                            "value-field": "id",
                                            "text-field": "employeeFullName",
                                          },
                                          model: {
                                            value:
                                              _vm.performanceRecord.employeeId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.performanceRecord,
                                                "employeeId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "performanceRecord.employeeId",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Price", "label-for": "price" } },
                          [
                            _c("b-form-input", {
                              attrs: {
                                name: "price",
                                placeholder: "Price",
                                type: "number",
                              },
                              model: {
                                value: _vm.performanceRecord.price,
                                callback: function ($$v) {
                                  _vm.$set(_vm.performanceRecord, "price", $$v)
                                },
                                expression: "performanceRecord.price",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Gift", "label-for": "gift" } },
                          [
                            _c("b-form-input", {
                              attrs: { name: "gift", placeholder: "Gift" },
                              model: {
                                value: _vm.performanceRecord.gift,
                                callback: function ($$v) {
                                  _vm.$set(_vm.performanceRecord, "gift", $$v)
                                },
                                expression: "performanceRecord.gift",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { sm: "12" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Date", "label-for": "date" } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                rules: "required",
                                name: "Date",
                                vid: "date",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-datepicker", {
                                          attrs: {
                                            id: "date",
                                            placeholder: "Date",
                                          },
                                          model: {
                                            value: _vm.performanceRecord.date,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.performanceRecord,
                                                "date",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "performanceRecord.date",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                model: {
                                  value: _vm.performanceRecord.addPayroll,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.performanceRecord,
                                      "addPayroll",
                                      $$v
                                    )
                                  },
                                  expression: "performanceRecord.addPayroll",
                                },
                              },
                              [_vm._v(" Add on Payroll ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.performanceRecord.addPayroll
                      ? _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                rules: "required",
                                name: "Payroll Month",
                                vid: "payrollMonth",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: "Select Month",
                                              "label-for": "selectMonth",
                                            },
                                          },
                                          [
                                            _c("b-form-select", {
                                              attrs: {
                                                id: "selectMonth",
                                                options: _vm.monthOptions,
                                              },
                                              model: {
                                                value:
                                                  _vm.performanceRecord
                                                    .payrollMonth,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.performanceRecord,
                                                    "payrollMonth",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "performanceRecord.payrollMonth",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-col",
                      {
                        staticClass: "d-flex justify-content-end",
                        attrs: { md: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "mr-2",
                            attrs: { type: "submit", variant: "primary" },
                          },
                          [
                            _vm._v(" Save "),
                            _vm.loading
                              ? _c("b-spinner", { staticClass: "mx-2" })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }